export default "__VITE_ASSET__D2GF3ymw__"